/**
 * Mock data for Teacher Dashboard
 *
 * Contains mock data for teacher-specific features, combined with real data
 * for courses where available.
 */

export const MOCK_PENDING_EVALUATIONS = [
  {
    id: 'eval-1',
    studentName: 'Alex Johnson',
    studentId: 'student-1',
    courseId: 'course-1',
    courseTitle: 'JavaScript Fundamentals',
    taskTitle: 'Final Project: Build a Todo App',
    taskType: 'assignment',
    submittedDate: '2025-11-26T14:30:00',
    priority: 'high',
    pageId: 'page-15',
  },
  {
    id: 'eval-2',
    studentName: 'Maria Garcia',
    studentId: 'student-2',
    courseId: 'course-1',
    courseTitle: 'JavaScript Fundamentals',
    taskTitle: 'Module 4 Exercise: Functions',
    taskType: 'assignment',
    submittedDate: '2025-11-25T10:15:00',
    priority: 'medium',
    pageId: 'page-10',
  },
  {
    id: 'eval-3',
    studentName: 'James Wilson',
    studentId: 'student-3',
    courseId: 'course-2',
    courseTitle: 'Web Design Basics',
    taskTitle: 'CSS Layout Challenge',
    taskType: 'assignment',
    submittedDate: '2025-11-24T16:45:00',
    priority: 'medium',
    pageId: 'page-8',
  },
  {
    id: 'eval-4',
    studentName: 'Sophie Chen',
    studentId: 'student-4',
    courseId: 'course-2',
    courseTitle: 'Web Design Basics',
    taskTitle: 'Responsive Design Project',
    taskType: 'file',
    submittedDate: '2025-11-23T09:00:00',
    priority: 'low',
    pageId: 'page-12',
  },
];

export const MOCK_STUDENT_ACTIVITY = [
  {
    id: 'activity-1',
    type: 'submission',
    studentName: 'Alex Johnson',
    courseTitle: 'JavaScript Fundamentals',
    action: 'Submitted Final Project',
    timestamp: '2025-11-26T14:30:00',
    icon: 'Task',
  },
  {
    id: 'activity-2',
    type: 'quiz_completed',
    studentName: 'Emma Davis',
    courseTitle: 'JavaScript Fundamentals',
    action: 'Scored 95% on Module 3 Quiz',
    timestamp: '2025-11-26T11:20:00',
    icon: 'Certificate',
  },
  {
    id: 'activity-3',
    type: 'discussion',
    studentName: 'Michael Brown',
    courseTitle: 'Web Design Basics',
    action: 'Posted in CSS Grid Discussion',
    timestamp: '2025-11-25T16:45:00',
    icon: 'Feedback',
  },
  {
    id: 'activity-4',
    type: 'enrollment',
    studentName: 'Sarah Miller',
    courseTitle: 'JavaScript Fundamentals',
    action: 'Enrolled in course',
    timestamp: '2025-11-25T09:00:00',
    icon: 'Student',
  },
  {
    id: 'activity-5',
    type: 'completion',
    studentName: 'David Lee',
    courseTitle: 'Web Design Basics',
    action: 'Completed Module 5',
    timestamp: '2025-11-24T14:15:00',
    icon: 'Check',
  },
];

export const MOCK_COURSE_STATS = {
  totalStudents: 156,
  activeStudents: 89,
  averageProgress: 67,
  completionRate: 42,
  pendingEvaluations: 4,
  coursesTeaching: 3,
};

export const MOCK_COURSE_PERFORMANCE = [
  {
    courseId: 'course-1',
    courseTitle: 'JavaScript Fundamentals',
    enrolledStudents: 78,
    averageProgress: 72,
    completionRate: 45,
    averageQuizScore: 82,
  },
  {
    courseId: 'course-2',
    courseTitle: 'Web Design Basics',
    enrolledStudents: 52,
    averageProgress: 58,
    completionRate: 35,
    averageQuizScore: 76,
  },
  {
    courseId: 'course-3',
    courseTitle: 'Advanced React Patterns',
    enrolledStudents: 26,
    averageProgress: 81,
    completionRate: 52,
    averageQuizScore: 88,
  },
];

export default {
  MOCK_PENDING_EVALUATIONS,
  MOCK_STUDENT_ACTIVITY,
  MOCK_COURSE_STATS,
  MOCK_COURSE_PERFORMANCE,
};
